// Global configuration
const ThemeColor = {
  Light: 1,
  Dark: 2,
};
const UserStatus = {
  Online: 1,
  Offline: 2,
  Away: 3,
  Busy: 4,
};
const ChatFilterOptions = {
  AllChats: 1,
  Friends: 2,
  Groups: 3,
  Unread: 4,
  Archived: 5,
};
const CallFilterOptions = {
  AllCalls: 1,
  Incoming: 2,
  Outgoing: 3,
  Missedcalls: 4,
};
const ProfileType = {
  Image: 1,
  Svg: 2,
  Text: 3,
};
export {
  ThemeColor,
  UserStatus,
  ChatFilterOptions,
  CallFilterOptions,
  ProfileType,
};
